import { PDPDeliveryProps } from '../types';
import { useEffect, useState } from 'react';
import Typography from '@/components/atoms/typography';
import Button from '@/components/atoms/button';
import { useParams } from 'next/navigation';
import useFormat from '@/hooks/useFormat';
import Loader from '../../loader';
import InfoTooltip from '@/components/atoms/info-tooltip';
import AddProductToProject from '@/components/organisms/project-builder/add-prod-to-project';
import QuantityWidget from '@/components/atoms/quantity-widget';
import useCart from '@/lib/hooks/useCart';
import useAccount from '@/lib/hooks/useAccount';
import { useCartConfig } from '@/providers/cart-config/CartConfigContext';
import { warehouseLocations } from '@/constants/inventoryAvailability';
import Link from 'next/link';
import { dateFormat } from '@/components/pages/dashboard/pages/order-tracking/helper';
const DeliveryDetails = ({
  itemCode,
  product,
  deliveryEstimate,
  isBuilderRange,
  quantity,
  setQuantity,
  productType,
  variantKey,
  setPostalCode,
  postalCode,
  loadingDeliverEstimate,
  warehouse,
  hasOutOfStockProductPart
}: PDPDeliveryProps) => {
  const { locale } = useParams();
  const { isCartEnabled } = useCartConfig();
  const { account } = useAccount();
  const [openAddToProject, setOpenAddToProject] = useState<boolean>(false);
  const [productToAdd, setProductToAdd] = useState<any>(null);
  const { addToCart } = useCart("", locale === "au" ? "plumbershub-au" : "plumbershub-nz");
  const [error, setError] = useState<string>();
  const [status, setStatus] = useState<string>();
  const [postcodeError, setPostcodeError] = useState<string>('');
  const [localPostcode, setLocalPostcode] = useState<string>(postalCode || '');

  const availableQuantity = 500;

  const isCriticalProduct = deliveryEstimate?.IsCritical?.toLowerCase() === 'yes';

  const qtyOnHand = deliveryEstimate?.['QtyAvailable'] || 0;
  const deliveryEstimateError = deliveryEstimate?.['Error/Message'];
  const isCustomerServiceError = deliveryEstimateError?.toLowerCase().includes('please call our customer service');
  const isOutOfStock = qtyOnHand === 0;
  //const isAddToOrderProduct = itemCode === '405050';
  //const isAddToOrderProduct = itemCode === '42-1367MBK';
  //const isGwaUser = account?.email?.toLowerCase().endsWith('@gwagroup.com') ?? false;
  const isAddToOrderProduct = itemCode === 'PHYPF011-AU';// && isGwaUser;

  let defaultWarehouseCode;

if (deliveryEstimate?.CentralStore == 'Yes') {
  defaultWarehouseCode = deliveryEstimate?.CentralStoreDefaultWarehouse;
} else if (deliveryEstimate?.DualStore == 'Yes') {
  defaultWarehouseCode = deliveryEstimate?.DualStoreDefaultWarehouse;
} else {
  defaultWarehouseCode = deliveryEstimate?.CustDefaultWarehouse;
}
console.log(defaultWarehouseCode);
const warehouseCity =
  warehouseLocations[defaultWarehouseCode] || 'GWA';

const availabilityStatus =
  hasOutOfStockProductPart
    ? 'Out of Stock'
    : isCriticalProduct
      ? 'N/A'
      : isOutOfStock
        ? 'Out of Stock'
        : 'N/A';
  const { formatCurrency } = useFormat();
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelAddProduct = () => {
    setOpenAddToProject(false);
    setProductToAdd(null);
  };

  const handleAddToProject = () => {
    setOpenAddToProject(true);
    setProductToAdd({ name: product?.name, sku: product?.sku });
  };

  const isAvailablityStatusNA = availabilityStatus === 'N/A';

  const getQtyOnHand = () => {
    if (deliveryEstimateError) {
      return 'Out of Stock';
    }
    if (isOutOfStock) {
      return 'Out of Stock';
    }
    if (qtyOnHand > 0) {
      return qtyOnHand.toString();
    }
    return 'Out of Stock';
  }
  const quantityChangeHandler = async (value: number) => {
    if (value <= 1) {
      setQuantity(1);
      return;
    }
    if (value > availableQuantity) {
      return;
    }
    setQuantity(value);
  };

  useEffect(() => {
    if (postalCode) {
      setLocalPostcode(postalCode);
    }
  }, [postalCode]);
  const addToOrderHandler = async () => {
    setIsLoading(true);

    try {
      const keyToUse = productType ? variantKey : itemCode;
      const res = await addToCart(product.sku, keyToUse as string, quantity);
      if (res?.data?.statusCode === 'OK') {
        setError("Product added to Cart");
        setStatus('success');
      } else if (['ExceededBrochureQty', 'ExceededProductQty'].includes(res?.data?.errorMessage)) {
        setError('Limit exceeded');
        setStatus('failure');
      } else {
        setError("Sorry cannot add product to the cart, please try again later");
        setStatus('failure');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      setError("Sorry cannot add product to the cart, please try again later");
      setStatus('failure');
    } finally {
      setIsLoading(false);
      setTimeout(() => setError(''), 5000);
    }
  }

  const formatDateToDDMMYYYY = (dateString: any) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const addBusinessDay = (date: Date) => {
    const newDate = new Date(date);

    switch (newDate.getDay()) {
      case 5: // Friday
        newDate.setDate(newDate.getDate() + 3);
        break;
      case 6: // Saturday
        newDate.setDate(newDate.getDate() + 2);
        break;
      default:
        newDate.setDate(newDate.getDate() + 1);
        break;
    }

    return newDate;
  };

    const getDate = () => {
    if (productType) {
      return '3-5 days';
    }
    const deliveryDate = deliveryEstimate?.EstimatedShipDate;
    // const isCriticalProduct = deliveryEstimate?.['Critical Product']?.toLowerCase() === 'yes';

    // if (isCriticalProduct) return 'N/A';
      if (availabilityStatus === 'Out of Stock' ) {
        const backorderDate = deliveryEstimate?.EstimatedShipDate;
        if (!backorderDate) {
          return 'On backorder';
        }

        const qty = Number(qtyOnHand);
        const shipDate = new Date(backorderDate);

        if (
          qtyOnHand === 'N/A' ||
          Number.isNaN(qty) ||
          qty <= 0
        ) {
          return `On backorder ${formatDate(addBusinessDay(shipDate))}`;
        }

        return `On backorder ${dateFormat(backorderDate, 'dd/MM/yyyy')}`;
      }

    if (deliveryDate) {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const delivery = new Date(deliveryDate);
      delivery.setHours(0, 0, 0, 0);
      if (delivery < currentDate) {
        return 'N/A';
      } else if (
        delivery.getDate() === currentDate.getDate() &&
        delivery.getMonth() === currentDate.getMonth() &&
        delivery.getFullYear() === currentDate.getFullYear()
      ) {
        const dayOfWeek = delivery.getDay() + 1;
        if (dayOfWeek === 6) {
          return formatDate(delivery.setDate(delivery.getDate() + 3));
        } else if (dayOfWeek === 0) {
          return formatDate(delivery.setDate(delivery.getDate() + 2));
        } else {
          return formatDate(delivery.setDate(delivery.getDate() + 1));
        }
      }
      return formatDate(deliveryDate);
    }
    return 'N/A';
  };

    const formatDate = (dateString: any) => {
      if (!dateString) return 'N/A';
      const newDate = new Date(dateString);
      const day = newDate.getDate();
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
      'October',
      'November',
      'December',
    ];
    const month = monthNames[newDate?.getMonth()];
    const year = newDate?.getFullYear();

    let daySuffix;
    if (day > 3 && day < 21) {
      daySuffix = 'th';
    } else {
      switch (day % 10) {
        case 1:
          daySuffix = 'st';
          break;
        case 2:
          daySuffix = 'nd';
          break;
        case 3:
          daySuffix = 'rd';
          break;
        default:
          daySuffix = 'th';
          break;
      }
    }

    return `${day}${daySuffix} ${month} ${year}`;
  };

  const handlePostcodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value && !/^\d*$/.test(value)) {
      return;
    }

    if (value.length > 5) {
      return;
    }

    setLocalPostcode(value);
    setPostcodeError('');
  };

  const isPostcodeValid = localPostcode.length >= 4 && localPostcode.length <= 5;

  const handlePostcodeSubmit = () => {
    if (!localPostcode) {
      setPostcodeError('Please enter a valid postcode');
      return;
    }

    if (localPostcode.length < 4) {
      setPostcodeError('Please enter a valid postcode');
      return;
    }
    if (setPostalCode) {
      setPostalCode(localPostcode);
      localStorage.setItem('--postal-code', localPostcode);
    }
  };


  const isPrototype = product?.lifecycle?.toUpperCase()?.trim() === 'PROTOTYPE';

  if (isPrototype) {
    return null;
  }

  return (
    <>
      <div className="mt-6 flex w-full flex-col items-stretch self-start bg-[#F3EDE9] py-5 px-5 md:p-5 lg:ml-auto lg:w-auto lg:max-w-[360px]">
        <>

{deliveryEstimate && isCriticalProduct && locale === 'au' ? (

            <>
              {/* <Typography className="mx-auto w-full text-center !font-semibold !leading-6 text-neutral-950 text-red-500 lg:max-w-[250px]">
                Call 13 14 16 to find stock availability
              </Typography> */}
              <>
                <div className="font-semibold leading-6 text-red-500 text-center w-full lg:max-w-[275px] mx-auto">
                  This product is in high demand. 
                  </div>
                  <div className="font-semibold leading-6 text-red-500 text-center w-full lg:max-w-[275px] mx-auto">
                  Please{" "}
                  <Link href="/contact-us" className="text-red-500 hover:text-red-600 !underline">
                    contact
                  </Link>{" "}
                  our team.
                </div>
              </>
            </>
          ) : (
            <>
              <div className="group relative !mb-[16px] flex items-center justify-between gap-4">
                <div className="my-auto whitespace-nowrap leading-6 text-zinc-800">
                  <Typography as={'span'} className="text-sm !font-medium !leading-6 text-neutral-950">
                    Postcode
                  </Typography>{' '}
                </div>
                <div className="relative !h-[34px]">
                  <input
                    placeholder="Enter Postcode"
                    className="h-[34px] w-[86px] focus:border-black focus:ring-black sm:w-[161px] rounded-[3px] border border-[#D1D1D1] px-[10px] py-[12px] !text-[12.5px] placeholder:text-[12.5px] placeholder:text-[#BEBEBE]"
                    value={localPostcode}
                    onChange={handlePostcodeChange}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && isPostcodeValid) {
                        handlePostcodeSubmit();
                      }
                    }}
                    type="text"
                    inputMode="numeric"
                    maxLength={5}
                  />
                  <div
                    className={`absolute inset-0 m-auto mr-[6px] h-[20px] w-[20px] ${isPostcodeValid ? 'cursor-pointer' : 'cursor-default'}`}
                    onClick={isPostcodeValid ? handlePostcodeSubmit : undefined}
                  >
                    <svg
                      className={isPostcodeValid ? 'stroke-black' : 'stroke-[#D1D1D1]'}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.8333 7.5L13.3333 10M13.3333 10L10.8333 12.5M13.3333 10L6.66667 10M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85787 2.5 10 2.5C14.1421 2.5 17.5 5.85787 17.5 10Z"
                        strokeWidth="1.08333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              {postcodeError && (
                <div className="!mb-[16px] flex justify-end">
                  <Typography className="text-[12px] text-red-500">{postcodeError}</Typography>
                </div>
              )}

              <div className="group relative !mb-[16px] flex items-center justify-between gap-2">
                <div className="my-auto whitespace-nowrap leading-6 text-zinc-800">
                  <Typography as={'span'} className="text-sm !font-medium !leading-6 text-neutral-950">
                    Ships on
                  </Typography>{' '}
                  <InfoTooltip
                    isOpen={true}
                    className="absolute hidden w-auto group-hover:block [&>div>div]:!left-[30px] [&>div]:!left-[5px] [&>div]:!top-[5px]"
                    place={`bottom-start`}
                    content={'When the items will leave GWA warehouse'}
                    hideIcon={true}
                  ></InfoTooltip>
                </div>
                {loadingDeliverEstimate ? (
                  <div className="flex items-center justify-center">
                    <Loader />
                  </div>
                ) : (
                  <Typography
                    as={'span'}
                    className="flex items-center justify-center self-stretch break-words rounded-[3rem] px-2.5 py-1.5 text-[13px] text-black text-center"
                    style={{ backgroundColor: '#CCECE8' }}
                  >
                    {getDate()}
                  </Typography>
                )}
              </div>

              <div className="group relative flex items-center justify-between gap-5">
                <div className="!font-medium !leading-6 text-sm text-neutral-950">
                  Availability
                </div>
                <InfoTooltip
                  isOpen={true}
                  className="absolute z-40 hidden w-auto !text-[16px] group-hover:block [&>div>div]:!left-[90px] [&>div]:!left-[-50px] [&>div]:!top-[20px]"
                  place={`bottom-start`}
                  content={`Stock availability in ${warehouseCity} warehouse`}
                  hideIcon={true}
                ></InfoTooltip>
                {loadingDeliverEstimate ? (
                  <div className="flex items-center justify-center">
                    <Loader />
                  </div>
                ) : (
                  <>
                    <div className="div">
                          <Typography
                            className={`items-stretch text-center justify-center self-stretch whitespace-nowrap ${isAvailablityStatusNA && 'min-w-[40px] !px-2'
                              } rounded-[3rem] px-3 py-1.5 text-[13px] text-[#000000]`}
                            style={{
                              backgroundColor: (() => {
                                if (hasOutOfStockProductPart) {
                                  return '#F7F7F7';
                                }

                                const qtyValue = getQtyOnHand();

                                if (qtyValue === 'N/A' || qtyValue === 'Out of Stock') {
                                  return '#F7F7F7';
                                }

                                const numValue = parseInt(qtyValue);

                                if (numValue <= 0) {
                                  return '#F7F7F7';
                                }

                                if (numValue > 0 && numValue <= 100) {
                                  return '#FFA500';
                                }

                                return '#47C429';
                              })(),
                            }}
                          >
                            {hasOutOfStockProductPart ? 'Out of Stock' : getQtyOnHand()}
                          </Typography>
                    </div>
                  </>
                )}
              </div>
              <div className='justify-left mt-2 flex'>
                <Typography className='text-16 leading-normal font-normal'>
                  {`Stock availability in ${warehouseCity} warehouse`}
                </Typography>
              </div>

            </>
          )}
        </>
        {!isCriticalProduct && <div>
          <div className="delivery-details-qty-wrapper mt-[16px] flex items-center justify-between gap-4">
            <span className='text-sm !font-medium !leading-6 text-neutral-950'>Quantity</span>
            <QuantityWidget
              showLabel={false}
              maxValue={productType ? 40 : availableQuantity < 500 ? availableQuantity : 500}
              minValue={1}
              defaultValue={1}
              value={quantity}
              onChange={quantityChangeHandler}
              disabled={isBuilderRange || deliveryEstimateError}
            />
          </div>
          {quantity >= 200 && quantity < 500 && (
            <span className="mt-3 flex justify-center text-xs font-normal leading-4 text-[#E32C53]">High quantity</span>
          )}
          {(productType ? quantity >= 40 : quantity >= 500) && (
            <span className="mt-3 flex justify-center text-xs font-normal leading-4 text-[#E32C53]">Max quantity</span>
          )}
          {quantity > qtyOnHand && qtyOnHand > 0 && !deliveryEstimateError && (
            <span className="mt-3 flex justify-center text-xs font-normal leading-4 text-[#E32C53] text-center">Your order will be split into two due to items
              being on backorder</span>
          )}
          {
            deliveryEstimateError && <>
              <span className="mt-3 flex justify-center text-xs font-normal leading-4 text-[#E32C53] text-center">{
                isCustomerServiceError ? "Call 13 14 16 to find stock availability" : "Please enter a valid postcode"
              }</span>
            </>
          }
          {
            !isBuilderRange && <div className="mt-4 flex justify-center text-xl leading-6 leading-8">
              <Typography style={{ fontSize: '20px', lineHeight: '28px' }} className="font-semibold">
                {formatCurrency(product.price * quantity, product?.currency)}
              </Typography>
            </div>
          }

        </div>}


        <div className={`mt-5 flex sm:flex-row flex-col items-center gap-4 ${isBuilderRange || isCriticalProduct || !isAddToOrderProduct || deliveryEstimateError || loadingDeliverEstimate || !isCartEnabled ? 'justify-center' : ''}`}>
          {/* {!isBuilderRange && ( */}
            <Button
              size="custom"
              className={`w-full disabled:pointer-events-none hover:disabled:shadow-none  disabled:border disabled:border-neutral-300 disabled:bg-neutral-200 disabled:text-gray-400 ${isBuilderRange || isCriticalProduct || !isAddToOrderProduct || deliveryEstimateError || loadingDeliverEstimate || !isCartEnabled ? 'w-auto' : 'w-full grow'} cursor-pointer items-stretch  justify-center whitespace-nowrap px-[1.5rem] py-3 text-center text-[16px] !font-semibold shadow-sm max-md:px-5 !bg-[#A6C9CC] !text-[#000000]`}
              onClick={handleAddToProject}
              // disabled={isBuilderRange}
            >
              Add to Project
            </Button>
          {/* )} */}

          {!isBuilderRange && !isCriticalProduct && isAddToOrderProduct && !deliveryEstimateError && !loadingDeliverEstimate && isCartEnabled && (
            <Button
              size="custom"
              onClick={addToOrderHandler}
              className={` ${isLoading ? '!bg-gray-400' : '!bg-[#000000]'} w-full grow cursor-pointer items-stretch justify-center whitespace-nowrap px-[1.5rem] py-3 text-center text-[16px] !font-semibold text-white shadow-sm max-md:px-5 disabled:!pointer-events-none disabled:!bg-gray-400 disabled:!text-neutral-100`}
              loading={isLoading}
            >
              Add to Order
            </Button>
          )}
        </div>
        {error && (
          <Typography
            className={`mt-2 text-sm font-medium leading-4 ${status === 'success' ? 'text-green-500' : 'text-[#E32C53]'
              }`}
            fontWeight={'medium'}
          >
            {error}
          </Typography>
        )}
      </div>
      <AddProductToProject open={openAddToProject} onCancel={handleCancelAddProduct} productToAdd={productToAdd} />
    </>
  );
};
export default DeliveryDetails;